import { render, staticRenderFns } from "./WxMaterialSelect.vue?vue&type=template&id=1f8891cd&scoped=true&"
import script from "./WxMaterialSelect.vue?vue&type=script&lang=js&"
export * from "./WxMaterialSelect.vue?vue&type=script&lang=js&"
import style0 from "./WxMaterialSelect.vue?vue&type=style&index=0&id=1f8891cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8891cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8891cd')) {
      api.createRecord('1f8891cd', component.options)
    } else {
      api.reload('1f8891cd', component.options)
    }
    module.hot.accept("./WxMaterialSelect.vue?vue&type=template&id=1f8891cd&scoped=true&", function () {
      api.rerender('1f8891cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wechat/WxMaterialSelect.vue"
export default component.exports